import { Box, Sheet } from "@mui/joy";
import { useTheme } from "@mui/joy/styles";
import { mediaUrl } from "../../../../../utils/mediaUrl";

export default function ImageOptionAvatar({ src = '', active = false, onClick = () => { } }) {
    const theme = useTheme();
    const accent = theme.colors.logo;

    const borderColor = active ? accent : 'transparent';
    const hoverBorderColor = active ? accent : `${accent}88`;

    return (
        <Sheet
            onClick={() => {
                onClick(src)
            }}
            sx={{
                border: `2px solid ${borderColor}`,
                '&:hover': {
                    borderColor: hoverBorderColor,
                },
                borderRadius: '50px',
                overflow: 'hidden',
                width: '80px',
                height: '80px',
                cursor: 'pointer',
                flexShrink: 0,
            }}
        >
            <Box
                component="img"
                src={mediaUrl(src)}
                alt="option"
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
        </Sheet>
    );
}
